import { useEffect, useState } from "react";

/**
 * Sticky, slim banner that appears whenever the browser reports it has lost
 * connectivity. The PWA service worker still serves the app shell, but
 * mutating API calls will fail — surfacing this to the user up front beats
 * showing an opaque network error.
 */
export function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-50 bg-amber-100 px-4 py-2 text-center text-sm font-medium text-amber-900 shadow-sm"
    >
      You’re offline — saved data is still visible, but new changes won’t sync until you reconnect.
    </div>
  );
}
